export default __webpack_public_path__ + "static/media/logoclean.ae6135d6.svg";